<ng-container>
  <img [src]="'../../../assets/icons/' + this.type + '/' + this.icon + '.svg'" [class]="color" />
</ng-container>